import React from 'react'
import { v4 as uuid } from "uuid";

const buscar = (url, cuerpo) => {
  return new Promise(function (resolve, reject) {
    Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
      var datos = $.parseJSON(respuesta.d);

      if (
        datos &&
        datos["Mensaje"] !== undefined &&
        datos["Detalle"] !== undefined &&
        datos["Interno"] !== undefined
      ) {
        reject(datos);
      }
      resolve(datos);
    });
  });
};

export const useBuscarHelper = (url, cuerpo) => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const consultaActualId = React.useRef();

  React.useEffect(() => {
    const obtenerDatos = () => {
      setLoading(true);
      setError(null);

      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const where = cuerpo || {};

      buscar(url, where)
        .then((data) => {
          if (consultaId === consultaActualId.current) {
            setData(data);
          }
        })
        .catch((err) => {
          setError(err);
        })
        .finally(() => setLoading(false));
    };
    obtenerDatos();
  }, [url, cuerpo]);

  return { data, loading, error };
};

export const useReporteHelper = (url, cuerpo) => {
  const data = React.useRef();
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const obtenerReporte = async () => {
    setLoading(true);

    const where = cuerpo || {};

    try {
      const response = await buscar(url, where);
      data.current = response;
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, obtenerReporte };
};

export const exportarHelper = async (url, cuerpo) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify({ exportarModel: cuerpo })
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.Message || `Error del servidor: ${response.statusText}`);
    }

    const blob = await response.blob();

    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = downloadUrl;

    link.setAttribute('download', `${uuid()}.xls`);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
};